// extracted by mini-css-extract-plugin
module.exports = {"loading_container":"loginLoader_loading_container__fQl_0","dot_windmill":"loginLoader_dot_windmill__En5K_","dotWindmill":"loginLoader_dotWindmill__ejJNw"};